// extracted by mini-css-extract-plugin
export default {"edit-img":"EditImg_edit-img__A021i","edit-spn":"EditImg_edit-spn__eJIS-"};